import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import { i18n } from './lib/i18n'
import { App } from './App'
import { ErrorBoundary } from './components/layout/ErrorBoundary'
import { bootstrapConsent } from '@/consent/bootstrap'
import './styles/globals.css'
import '@/styles/print.css'
// flag-icons — SVG-флаги для JurisdictionBadges (на Windows
// regional-indicator emoji рендерятся как буквы, нужен внешний источник).
import 'flag-icons/css/flag-icons.min.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})

// Async bootstrap (GPC + consent hydration + lazy Metrika) ДО React mount —
// гарантирует что Yandex.Metrika не грузится до явного consent (CNIL compliance).
void bootstrapConsent().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </I18nextProvider>
      </ErrorBoundary>
    </React.StrictMode>
  )
})
